import { h } from 'preact'
import { CurrentUserContext, UserPermissionContext } from '../../server-middleware/userContext'
import Configurator, { isThemeType, ThemeTypes } from '../theme-configuration/configurator'
import { parse } from 'qs'
import CustomizationToolbar, { pageOptions } from '../widget-editor/toolbar'
import Portal from 'preact-portal'
import TranslationForm from '../../components/translation-form/TranslationForm'

interface Props {
  controlUrl: string
}

function getEnabledTheme (): ThemeTypes {
  if (typeof window === 'undefined') {
    return null
  }
  const theme = parse(window.location.search, { ignoreQueryPrefix: true }).theme

  if (typeof theme === 'string' && isThemeType(theme)) {
    return theme
  }
  return null
}

function getWidgetConfigurationPage (): pageOptions | null {
  if (typeof window === 'undefined') {
    return null
  }

  const path = window.location.pathname
  if (path === '/') return 'homepage'
  if (path === '/ideas') return 'ideation'
  if (path === '/product-updates') return 'productUpdates'
  if (path === '/knowledge-base') return 'knowledgeBase'

  return null
}

function isCustomizing () {
  return typeof window !== 'undefined' && window.location.search.includes('customize')
}

function AdminToolbar ({ controlUrl }: Props) {
  const customizationPage = getWidgetConfigurationPage()

  return (
    <CurrentUserContext.Consumer>
      {(user) => {
        if (!user || !user.isModerator) return null

        return (
          <UserPermissionContext.Consumer>
            {(permissionsContext) => {
              const { permissions } = permissionsContext

              if (isCustomizing() && permissions.includes('control.appearance') && customizationPage) {
                return <CustomizationToolbar page={customizationPage} controlUrl={controlUrl} elements={[]} />
              }

              return (
                <div class='translation--switch is-hidden-mobile-only'>
                  <a href={controlUrl} class='btn btn--S btn--insided-brand' target='_blank' rel='noreferrer'>Control</a>

                  {permissions.includes('control.appearance')
                    ? <Configurator theme={getEnabledTheme()} />
                    : null}

                  {customizationPage && permissions.includes('control.appearance')
                    ? <a href='?customize' data-track={JSON.stringify({ type: 'Destination Configuration Mode Activated' })} class='btn--S btn--purple'>Customize</a>
                    : null}

                  <div
                    class='translation--switch--container' data-component='translation-switch' data-data={JSON.stringify({
                      controlUrl: controlUrl,
                      canEditPhrases: permissions.includes('control.settings.translation.edit'),
                      liveEdit: false // TODO: App.session.get('liveEdit')
                    })}
                  />
                  <Portal into='body'>
                    <TranslationForm liveEdit={false} />
                  </Portal>
                </div>
              )
            }}
          </UserPermissionContext.Consumer>
        )
      }}
    </CurrentUserContext.Consumer>
  )
}
export default AdminToolbar
